export default {
    state: {
        health_care: '',
        order_data: {}
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/state.js